<template>
  <div>
    <van-nav-bar
      title="资金划转"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/agency')"
    />
    <van-form @submit="transfer">
      <van-cell title="佣金金额">
        <template #default>
          <span>{{ agent_account }}元</span>
        </template>
      </van-cell>
      <van-field
        v-model="money"
        error
        required
        type="digit"
        label="划转金额"
        placeholder="请输入划转金额"
        input-align="right"
      />
      <van-button size="small" round  type="danger" block>划转</van-button>
    </van-form>
  </div>
</template>

<script>
    export default {
      name: "Transfer",
      data(){
        return{
          agent_account:'',
          money:'',
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        getUser() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code === 1) {
                that.agent_account = resData.data.agent_account;
              } else if (res.data.code === 0 || res.data.code === -1) {
                that.$toast.fail(resData.msg);
              }
            });
        },
        transfer(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "transfer_money",
              token: sessionStorage.getItem("token"),
              number: that.money,
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: res.data.msg,
                  onClose:function () {
                    that.$router.push('/member/agency')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });

        }
      },
      mounted:function () {
        this.isLogin();
        this.getUser();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AgencyTransfer.vue